module.exports = __webpack_public_path__ + "static/media/scopus_tbg.18d60fae.png";